/**
 * @generated SignedSource<<555b32831c0aad1f48cff086598b6224>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModule_componentModule$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleControl_componentModule">;
  readonly " $fragmentType": "HpSharedFeaturedModule_componentModule";
};
export type HpSharedFeaturedModule_componentModule$key = {
  readonly " $data"?: HpSharedFeaturedModule_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModule_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isSaleVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModule_componentModule",
  "selections": [
    {
      "condition": "isSaleVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedFeaturedModuleControl_componentModule"
        }
      ]
    }
  ],
  "type": "FeaturedModule",
  "abstractKey": null
};

(node as any).hash = "b8872cc043ee43da6f41aaaacb515786";

export default node;
